// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".active-submission[data-v-0cd8c396]{background-color:rgba(147,201,15,.1450980392156863)}.orange-icon[data-v-0cd8c396]{color:#ff9e1b!important}", ""]);
// Exports
module.exports = exports;
